import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from "@angular/router";
import { UserService } from 'src/app/services/user.service';
import { AlertService } from 'src/app/services/alert.service';
import { NzNotificationService } from 'ng-zorro-antd';


@Component({
    templateUrl: 'after-account-setup.component.html',
    selector: 'after-account-setup',
    styleUrls: ['./after-account-setup.component.scss']
})

export class AfterAccountSetupComponent {
    model: any = {};
    loading = false;
    token = '';

    constructor(
        private router: Router,
        private userService: UserService,
        private alertService: AlertService,
        private route: ActivatedRoute,
        private notification: NzNotificationService
        ) { }

    ngOnInit() {
        // this.token = this.route.snapshot.paramMap.get("token");
    }

    changePassword() {
        this.loading = true;
        this.userService.changePassword(this.model, this.token)
            .subscribe(
                data => {
                    this.alertService.success('Password changed successfully', true);
                    this.router.navigate(['/login']);
                    this.createNotificationCreated();
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    createNotificationCreated(): void {
        this.notification.create(
            'success',
            'Password updated',
            '',
            { nzDuration: 2000 }
        );
    }
    
}
